import { DxContainer, DxToggle, DxIcon, DxText } from '@dvag/design-system-react';
import { checkIcon } from 'utils/util';
import i18next from 'i18next';
import '../../style.css';

export const QuickAccessSection = ({
  enabled,
  onToggle,
  readMode,
}: {
  enabled: boolean;
  onToggle: (checked: boolean) => void;
  readMode: boolean;
}) => {
  return (
    <DxContainer color="transparent" className="settings-section">
      <DxIcon
        icon={checkIcon('haus')}
        size={24}
        className="settings-section-icon"
        color="primary"
      />
      <DxContainer color="transparent" className="settings-section-content">
        <DxText type="Infotext-Small" color="gray-66">
          {i18next.t('vpDigitalSettings.budget.labelSmall')}
        </DxText>
        <DxText type="Paragraph-Standard">
          {i18next.t('vpDigitalSettings.budget.hideQuickAccess')}
        </DxText>
      </DxContainer>
      <DxToggle
        checked={enabled}
        onCheckedChange={(e) => onToggle(e.detail)}
        data-testid="budget-toggle"
        disabled={readMode}
      />
    </DxContainer>
  );
};
